"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVolume = void 0;
const createVolume = ({ httpClient, }) => ({ description, filesystem_label, filesystem_type, name, region, size_gigabytes, snapshot_id, tags, }) => {
    const path = '/volumes';
    const body = {
        description,
        filesystem_label,
        filesystem_type,
        name,
        region,
        size_gigabytes,
        snapshot_id,
        tags,
    };
    const url = `${path}`;
    return httpClient.post(url, body);
};
exports.createVolume = createVolume;
//# sourceMappingURL=create-volume.js.map